export default function(characters = 'a-z,A-Z,0-9,#', size = 32) {
  let charactersArray = characters.split(',');  
  let CharacterSet = '';
  let password = '';
  
  if( charactersArray.indexOf('a-z') >= 0) {
    CharacterSet += 'abcdefghijklmnopqrstuvwxyz';
  }
  if( charactersArray.indexOf('A-Z') >= 0) {
    CharacterSet += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  }
  if( charactersArray.indexOf('0-9') >= 0) {
    CharacterSet += '0123456789';
  }
  if( charactersArray.indexOf('#') >= 0) {
    CharacterSet += '![]{}()%&*$#^<>~@|';
  }
  if( charactersArray.indexOf('a-h') >= 0) {
    CharacterSet += 'abcdefgh';
  }
  if( charactersArray.indexOf('j-k') >= 0) {
    CharacterSet += 'jk';
  }
  if( charactersArray.indexOf('m-n') >= 0) {
    CharacterSet += 'mn';
  }
  if( charactersArray.indexOf('p-z') >= 0) {
    CharacterSet += 'pqrstuvwxyz';
  }
  if( charactersArray.indexOf('A-K') >= 0) {
    CharacterSet += 'ABCDEFGHIJK';
  }
  if( charactersArray.indexOf('M-N') >= 0) {
    CharacterSet += 'MN';
  }
  if( charactersArray.indexOf('P-Z') >= 0) {
    CharacterSet += 'PQRSTUVWXYZ';
  }
  if( charactersArray.indexOf('2-9') >= 0) {
    CharacterSet += '23456789';
  }
  
  for(let i=0; i < size; i++) {
    password += CharacterSet.charAt(Math.floor(Math.random() * CharacterSet.length));
  }
  return password;
}